// Define an array of screen set configurations
const screenSets = [
    {
        screenSet: $("#gigyaScreenSet").val(),
        startScreen: $("#gigyaStartScreen").val(),
        containerID: $("#gigyaContainerId").val()
    },
    {
        screenSet: $("#gigyaVetClinicScreenSet").val(),
        startScreen: $("#gigyaVetClinicStartScreen").val(),
        containerID: $("#gigyaVetClinicContainerId").val()
    },
    {
        screenSet: $("#gigyaPetInfoScreenSet").val(),
        startScreen: $("#gigyaPetInfoStartScreen").val(),
        containerID: $("#gigyaPetInfoContainerId").val()
    },
    // Add more screen set configurations as needed
];

// // Loop through the screenSets array and display each screen set
screenSets.forEach((screenSetConfig) => {
    gigya.accounts.showScreenSet(screenSetConfig, { // eslint-disable-line
        onAfterSubmit: function (eventObj) {
            // Handle the response here
            if (
                eventObj.screen === "gigya-pet-owner-update-profile-screen" ||
                eventObj.screen === "gigya-vet-update-profile-screen" ||
                eventObj.screen === "gigya-breeder-update-profile-screen" ||
                eventObj.screen === "gigya-staff-update-profile-screen" ||
                eventObj.screen === "gigya-family-update-profile-screen"
            ) {
                const customerId = eventObj.response.UID;
                const customerFirstName = eventObj && "profile" in eventObj ? eventObj.profile.firstName : "";
                const customerEmail = eventObj && "profile" in eventObj ? eventObj.profile.email : "";
                const customerLastName = eventObj && "profile" in eventObj ? eventObj.profile.lastName : "";
                const customerData = eventObj.data;
                const customerContactNumber = eventObj && "data" in eventObj ? eventObj.data.phone : "";
                const updateProfileUrl = $("#gigyaUpdateProfileUrl").val();
            
                if (updateProfileUrl) {
                    const xhr = new XMLHttpRequest();
                    xhr.open("POST", updateProfileUrl, false);
                    xhr.setRequestHeader("Content-Type", "application/json");
                    var payload = {
                        customerId,
                        customerFirstName,
                        customerEmail,
                        customerContactNumber,
                        customerLastName,
                        customerData,
                    };
            
                    var data = JSON.stringify(payload);
                    xhr.send(data);
                }
            }
        }
    });
});

gigya.accounts.addEventHandlers({ // eslint-disable-line
    /**
    * Handles Gigya reentry
    * @param {Object} eventObj - Gigya event object
    */
    onLogin: function (eventObj) {
        const customerId = eventObj.UID;
        const customerFirstName =  eventObj && "profile" in eventObj ? eventObj.profile.firstName : "";
        const customerEmail = eventObj && "profile" in eventObj ? eventObj.profile.email : "";
        const customerLastName = eventObj && "profile" in eventObj ? eventObj.profile.lastName : "";
        const customerData = eventObj.data;
        const customerContactNumber = eventObj && "data" in eventObj ? eventObj.data.phone : "";
        const customerTimeStamp = eventObj.signatureTimestamp;
        const customerSignature = eventObj.UIDSignature;
        const eventName = eventObj.fullEventName;
        const isNewUser = eventObj.newUser;
        const source = eventObj.source;
        const reentryUrl =  $("#gigyaReentryUrl").val();
        
        if (reentryUrl) {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", reentryUrl, false);
            xhr.setRequestHeader("Content-Type", "application/json");
            var payload = {
                customerId,
                customerFirstName,
                customerEmail,
                customerContactNumber,
                customerLastName,
                customerData,
                customerTimeStamp,
                customerSignature,
                eventName,
                isNewUser,
                source
            };

            var data = JSON.stringify(payload);

            xhr.addEventListener("load", function () {
                if (xhr.status) {
                    var responseText = xhr.responseText;
                    var responseTextJson;
                    try { 
                        responseTextJson = responseText ? JSON.parse(responseText) : null;
                    } catch (e) {
                        responseTextJson = null;
                    }

                    if (responseTextJson != null && "redirectUrl" in responseTextJson && responseTextJson.redirectUrl) {
                        window.location.href = responseTextJson.redirectUrl;
                    }
                }
            });
            xhr.addEventListener("error", function () {
                console.log("Gigya reentry failed. Network error");
            });
            xhr.addEventListener("abort", function () {
                console.log("Gigya reentry failed. Request aborted");
            });
            
            xhr.send(data);
        }
    }
});
